<table
  class="comp table-striped borderless"
  width="100%"
  cellspacing="0"
  border="0"
  (mouseleave)="rowHovered(null)"
>
  <tbody *ngIf="students && students.length > 0">
    <tr
      *ngFor="let student of students; let i = index"
      [ngClass]="{ hoveredRow: fixedColRowHoveredIndex == i }"
      (mouseover)="rowHovered(i)"
    >
      <td
        *ngFor="let column of columns; let first = first; let j = index"
        class="comp comp-value"
        [ngClass]="column.title == GROUP_STATUS_CONSTANT ? 'group-status' : ''"
      >
        <div
          *ngIf="student[column.id]"
          [tooltip]="ourStudentsTooltip"
          container="body"
          [adaptivePosition]="false"
          [attr.aria-label]="getAriaLabel(student, column)"
        >
          <!--if there is a column object with data for this student's metric -->
          <span
            [ngStyle]="{
              color: student[column.id] ? student[column.id].color : ''
            }"
            class="comp-overall-value"
          >
            <ng-container *ngIf="student[column.id].alpha">
              {{ student[column.id].alpha }}
            </ng-container>
            <ng-container *ngIf="!student[column.id].alpha">
              {{ student[column.id].prefix
              }}{{
                column["roundTo"] !== undefined
                  ? (student[column.id].y
                    | number
                      : "1." + column["roundTo"] + "-" + column["roundTo"])
                  : (student[column.id].y | number)
              }}{{ student[column.id].suffix }}
            </ng-container>
          </span>
          <span class="change">
            <!-- change -->
            <img
              *ngIf="student[column.id].changeDirection == 'up'"
              class="arrow"
              [src]="'../../assets/images/arrow_up.svg'"
            />
            <img
              *ngIf="student[column.id].changeDirection == 'down'"
              class="arrow"
              [src]="'../../assets/images/arrow_down.svg'"
            />
            <img
              *ngIf="student[column.id].changeDirection == 'none'"
              class="arrow_sideways"
              [src]="'../../assets/images/arrow_sideways.svg'"
            />
            <p class="change-value" *ngIf="student[column.id].changeValue">
              {{ student[column.id].prefix }}
              {{
                column.roundTo !== undefined
                  ? student[column.id].changeValue >= 1000
                    ? (student[column.id].changeValue / 1000).toFixed(0) + "k"
                    : (student[column.id].changeValue
                      | number: "1." + column.roundTo + "-" + column.roundTo)
                  : (student[column.id].changeValue | number)
              }}
              {{ student[column.id].suffix }}
            </p>
          </span>
          <ng-template #ourStudentsTooltip>
            <our-students-tooltip
              [student]="student"
              [column]="column"
            ></our-students-tooltip>
          </ng-template>
        </div>
        <div *ngIf="student[column.id] == null && column.id == -1">
          <!--Group Status column -->
          <img
            [src]="'../../assets/images/' + student.status + '.svg'"
            class="group-status-img"
            [ngClass]="{
              'does-not-meet-img':
                student.status == 'in_group_but_does_not_meet_criteria'
            }"
            [alt]="student.status"
            [matTooltipPosition]="'below'"
            [matTooltip]="groupStatusTooltipMapping[student.status]"
            *ngIf="student.status"
          />
        </div>
        <div *ngIf="student[column.id] == null && column.id != -1">
          <!-- no data for this student's metric -->
          <span class="comp-overall-value">---</span>
          <div class="change-spacer"></div>
        </div>
      </td>
    </tr>
  </tbody>
  <tbody *ngIf="!students || students.length == 0">
    <tr>
      <td
        *ngFor="let column of columns; let first = first; let j = index"
        class="comp comp-value"
      ></td>
    </tr>
  </tbody>
</table>
<p *ngIf="!students || students.length == 0" class="no-match">
  No students meet selected filter criteria
</p>
